import { type Action, action } from "easy-peasy";

import DEFAULT_REGULAR_ONLY from "./default";

export type RegularOnlyModel = {
  value: boolean;
  set: Action<RegularOnlyModel, boolean>;
};

const regularOnlyModel: RegularOnlyModel = {
  value: DEFAULT_REGULAR_ONLY,
  set: action((state, payload) => {
    state.value = payload;
  }),
};

export default regularOnlyModel;
